import { render } from "./HotTip.vue?vue&type=template&id=6b600f6d&scoped=true"
import script from "./HotTip.vue?vue&type=script&lang=js"
export * from "./HotTip.vue?vue&type=script&lang=js"

import "./HotTip.vue?vue&type=style&index=0&id=6b600f6d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b600f6d"

export default script